export default "__VITE_ASSET__CpODpgwu__"